var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWardIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10 10"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#bec3e1",
    d: "M5.262 3.544l1.061 5.384L4.995 10 3.667 8.928l1.06-5.384.268.361zM6.257 0l.42.74-1.672 2.045L3.333.74l.42-.74zm1.169 3.536L8.52 4.98l-1.757.705L6 3.268l1.16-1.141H10zM4 3.268l-.763 2.416-1.757-.705 1.094-1.443S.19 3.684 0 2.126h2.84z"
  })));
}
export default __webpack_public_path__ + "static/svg/ward-icon.svg";
export { SvgWardIcon as ReactComponent };